import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Plus } from 'lucide-react'
import { listStaff } from '../../api/practice'
import ErrorBanner from '../../components/ErrorBanner'
import Spinner from '../../components/Spinner'
import { StatusBadge } from '../../components/PageParts'
import { PracticeTabs } from './practiceShared'

export const staffStatus = (p) => (!p.active ? <StatusBadge label="Switched off" tone="muted" />
  : p.waiting ? <StatusBadge label="Hasn’t chosen a password" tone="warn" /> : <StatusBadge label="Active" tone="good" />)

/** A practice's people, and which clients each can open (admins only). */
export default function Staff() {
  const { data, isLoading, error } = useQuery({ queryKey: ['practice-staff'], queryFn: listStaff })
  const people = data?.staff || []
  const names = Object.fromEntries((data?.clients || []).map((c) => [c.client_id, c.name]))
  return (
    <div className="ci-page">
      <PracticeTabs />
      <div className="ci-header-row">
        <div className="ci-title-block">
          <div>
            <h1>Staff</h1>
            <div className="ci-title-meta">Who works in your practice. Admins open every client; staff open the clients you give them.</div>
          </div>
        </div>
        <div className="ci-header-actions">
          <Link className="ci-btn ci-btn-primary" to="/practice/staff/new"><Plus size={15} />Add someone</Link>
        </div>
      </div>
      {error && <ErrorBanner message={error.message || 'Couldn’t load your staff.'} />}

      <div className="ci-table-wrap">
        <div className="ci-table-scroll">
          <table className="ci-table fit-sm">
            <thead><tr><th>Person</th><th>Can open</th><th className="center hide-sm">Status</th></tr></thead>
            <tbody>
              {isLoading ? (
                <tr><td colSpan="3"><Spinner label="Loading your staff…" /></td></tr>
              ) : people.map((p) => (
                <tr key={p.user_id}>
                  <td>
                    <Link className="ci-strong mf-row-link" to={`/practice/staff/${p.user_id}`}>{p.full_name}</Link>
                    <span className="cell-sub">@{p.username}{p.email ? ` · ${p.email}` : ''}{p.user_id === data?.me ? ' · you' : ''}</span>
                    {(!p.active || p.waiting) && <span className="cell-sub show-sm-block">{staffStatus(p)}</span>}
                  </td>
                  <td>
                    <span className="mf-roles">
                      {p.admin ? <><span className="mf-role">Admin</span><span className="mf-role">Every client</span></>
                        : p.clients.length ? p.clients.map((c) => <span key={c} className="mf-role">{names[c]}</span>)
                          : <span className="ci-muted-cell">No clients yet</span>}
                    </span>
                  </td>
                  <td className="center hide-sm">{staffStatus(p)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="ci-pagination"><span className="ci-page-info">{people.length} {people.length === 1 ? 'person' : 'people'}</span></div>
      </div>
    </div>
  )
}
